import React from 'react';
import * as S from './styles';

interface WhitelistAdmProps {
	isVisiable: boolean;
}

export default function WhitelistAdm({ isVisiable }: WhitelistAdmProps) {
	return (
		<S.container $isShow={isVisiable}>
			<h1>WhitelistAdm</h1>
		</S.container>
	);
}
